import { render, staticRenderFns } from "./ListItemSettingsReset.vue?vue&type=template&id=b1f7dd30"
import script from "./ListItemSettingsReset.vue?vue&type=script&lang=js"
export * from "./ListItemSettingsReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports